import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useEffect, useState } from "react";
import useShop from "@babackapp/private-api-client/client/use-shop";
import { useParams } from "react-router-dom";
import { Button } from "@babackapp/ui/components/button";
import { useGetCustomerCarrierPortalLink } from "@babackapp/private-api-client/client/use-get-customer-carrier-portal-link";

export default function BillingWarningCarrierSetupPopup() {
  const params = useParams<{ shopId: string }>();
  const shopId = params.shopId || "";
  const { data: shop } = useShop(shopId);
  const { data: carrierPortalLink } = useGetCustomerCarrierPortalLink(shopId);
  useEffect(() => {
    console.log("carrierPortalLink", carrierPortalLink);
  }, [carrierPortalLink]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (shop?.billing.stripe.warningCarrierStripeAccount) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [shop]);

  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>
          <div className="font-bold text-lg">Prélèvement SEPA</div>
        </DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-2">
            <div>Chers Marchands,</div>
            <div>
              À l’approche des fêtes de fin d’année, Baback renforce ses
              conditions de paiement pour assurer un service à la hauteur de vos
              attentes.
            </div>
            <div>
              Nous vous demandons de bien vouloir renseigner un mandat SEPA
              permettant à BABACK LOG SAS de prélever vos factures transport
              uniquement en cas de retard de paiement supérieur à 5 jours après
              l’échéance habituelle de 30 jours.
            </div>
            <div>
              Ce prélèvement ne sera utilisé qu’en dernier recours, et les
              commissions des PSP seront refacturées à hauteur de 100 € HT par
              tranche de 5 000 € prélevés.
            </div>
            <div>
              Nous comptons sur votre compréhension et votre rigueur afin que
              cette mesure reste exceptionnelle.
            </div>
            <div>Merci pour votre collaboration et votre confiance,</div>
            <div>L’équipe Baback</div>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button
            onClick={() =>
              carrierPortalLink && window.open(carrierPortalLink, "_blank")
            }
          >
            Renseigner le mandat SEPA
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
